import React from 'react';
import ReactDOM from 'react-dom/client';
import './App.css'
import Home from './pages/Home/Home';
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<Home />);
